export default ['bayer', 'regenera'] as const;
